import ngGoogleAnalytics from 'angular-google-analytics';
import AnalyticsService from './analytics.service';
import run from './analytics.run';
import config from './analytics.config';

export default angular.module('app.analytics', [ngGoogleAnalytics.name])
	.service(AnalyticsService.id(), AnalyticsService)
	.config(config)
	.run(run).name;
